/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { EvaporativeCondenser } from "./modelEvaporativeCondenser";

class ControllerEvaporativeCondenser extends ControllerModel {
  constructor() {
    super("ControllerEvaporativeCondenser");

    this.setNewNode = (callback) => {
      let evaporativeCondenser = new EvaporativeCondenser();
      evaporativeCondenser.decorate(callback);

      this.addNode(evaporativeCondenser);
      SingletonFlowchart.SaveStatus();
    };

    this.loadNode = (node, callback) => {
      let evaporativeCondenser = new EvaporativeCondenser();
      evaporativeCondenser.copyFrom(node);
      evaporativeCondenser.decorate(callback);
      this.addNode(evaporativeCondenser);
    };

    this.getProperties = async (node) => {
      let n = new EvaporativeCondenser();
      await n.copyFrom(node);
      return n.data
    }

    this.getNode = (node) => {
      let n = new EvaporativeCondenser();
      n.copyFrom(node);
      return n
    }
  }
}

export { ControllerEvaporativeCondenser };
